// Re-export everything from the centralized grouping utility
// This maintains backward compatibility while using the centralized logic
export {
  shouldLocationConsolidateBillets,
  groupBilletsByHeat,
  groupBilletsForDisplay,
  sortHeatsByPosition,
} from "./centralizedBilletGrouping";

import { BilletGroup } from "../models";

/**
 * Sorts billet groups within a heat by position in descending order
 * @param groups Array of BilletGroup objects
 * @returns Sorted array of BilletGroup objects
 */
export const sortGroupsByPosition = (groups: BilletGroup[]): BilletGroup[] => {
  return groups.sort((a, b) => b.Position - a.Position);
};
